exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".tip-cont{width:36rem;height:24rem;background:url(\"https://d2rzfffph148bz.cloudfront.net/web_store/images/popup_bg.png\") 50% no-repeat;background-size:100% 100%;margin:0 auto;box-sizing:border-box;padding:4rem 2rem}.tip-cont span{color:#fff}.tip-cont .tip-content{height:13.2rem}.tip-cont .btns .btn{display:inline-block;width:13rem;height:5rem;line-height:4.6rem}.tip-cont .btns .confirm{background:url(\"https://d2rzfffph148bz.cloudfront.net/web_store/images/button_yes.png\") 50% no-repeat;background-size:100% 100%}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-ab73163a","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/dist/cjs.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/popup/Tip.vue
// module id = 349
// module chunks = 0